import type { IVennChartData } from "../types";
import type { ISiteLegendItem } from "app/pages/website-analysis/traffic-sources/mmx/components/ChannelAnalysisChart/ChannelAnalysisChartContainer";
import type { IChosenSiteLegend } from "./sharedTypes";
import { sortArrayAsOtherArray } from "app/UtilitiesAndConstants/UtilityFunctions/sort";

export const buildChosenLegendItems = (
    vennChartData: IVennChartData,
    selectedSites: ISiteLegendItem[],
): IChosenSiteLegend[] => {
    const legendItems = vennChartData
        .filter(({ sets }) => sets.length === 1)
        .map((dataItem) => {
            const { color, sets } = dataItem;

            // Check if the current site is auto suggest.
            // First, check if the site has an explicit isSuggested property from the input.
            // Otherwise, it's auto suggested if it doesn't appear on the user selected sites.
            const siteName = sets.join();
            const matchedSite = selectedSites.find((site) => site.name === siteName);
            const isAutoSuggest = matchedSite
                ? Boolean((matchedSite as any).isSuggested)
                : selectedSites.every((site) => site.name !== siteName);

            return {
                name: sets.join(),
                color,
                icon: "string",
                image: "string",
                smallIcon: true,
                isAutoSuggest: isAutoSuggest,
            };
        });

    return sortChosenLegendItems(legendItems, selectedSites);
};

const sortChosenLegendItems = (legendsToSort: IChosenSiteLegend[], selectedSites: ISiteLegendItem[]) => {
    const sorted = sortArrayAsOtherArray(legendsToSort, selectedSites, "name");
    const hasSingleSelection = selectedSites.length === 1;
    const adjustedSort = hasSingleSelection ? sortWithUserSelectedSiteAtStart(sorted, selectedSites) : sorted;

    return adjustedSort;
};

/**
 * In case we had a single selection, and the rest of the legend items are from auto suggest
 * then we should move the user selected site to the first index of the sorted array.
 * (product request)
 */
const sortWithUserSelectedSiteAtStart = (legendsToSort: IChosenSiteLegend[], selectedSites: ISiteLegendItem[]) => {
    if (legendsToSort.length <= 0 || selectedSites.length <= 0) {return legendsToSort;}

    const userSelectedSiteLegend = legendsToSort.find((site) => !site.isAutoSuggest);
    const autoSuggestLegends = legendsToSort.filter((site) => site.isAutoSuggest);

    return [userSelectedSiteLegend, ...autoSuggestLegends];
};
